import { useCallback, useState } from 'react'

import { RequestStatus } from 'core/domain/Request'

import { sentry } from 'legacy/utils/sentry'

import { type NewEmployee, type Employee } from '../../domain/Employee'
import { type AddEmployeeResponseError } from '../../infra/CarrierRepository'
import {
  createAndAssignDriver,
  CreateAndAssignDriverError,
} from '../../use-cases/createAndAssignDriver'

type AddAndAsignDriverParams = {
  carrierUUID: string
  shipmentUUID: string
  newEmployee: NewEmployee
}

export function useCreateAndAssignDriver() {
  const [requestStatus, setRequestStatus] = useState(RequestStatus.Initial)
  const [driver, setDriver] = useState<Employee>()
  const [error, setError] = useState<AddEmployeeResponseError>()

  const createAndAssign = useCallback(
    async ({ carrierUUID, shipmentUUID, newEmployee }: AddAndAsignDriverParams) => {
      setError(undefined)
      setRequestStatus(RequestStatus.Pending)
      try {
        const response = await createAndAssignDriver({
          carrierUUID,
          shipmentUUID,
          employee: newEmployee,
        })
        setRequestStatus(RequestStatus.Done)
        setDriver(response)
      } catch (error) {
        if (error instanceof CreateAndAssignDriverError) {
          setError(error.errors)
        }
        sentry.log(error)
        setRequestStatus(RequestStatus.Error)
      }
    },
    []
  )

  return { createAndAssign, requestStatus, driver, error }
}
